interface Props {
  studentName: string
  message: string
}
const parseHtml = (str) => {
  return (
    str
      ?.replace(/background-color: rgb\(249, 251, 253\);/g, '')
      .replace(/<p><br><\/p>/g, '')
      .replace(/<p/g, "<p class='mb-0'") || ''
  )
}
const MessageToStudent = ({ studentName = 'Student', message }: Props) => {
  return (
    <div className="mt-[24px] flex flex-col items-start justify-start">
      <div className="text-[20px] font-bold text-gray-800">{`Message to ${studentName}`}</div>
      <div
        className="keep-all mt-[16px] w-full rounded-[10px] bg-gray-50 p-[16px]"
        dangerouslySetInnerHTML={{
          __html: parseHtml(message),
        }}
      ></div>
    </div>
  )
}

export default MessageToStudent
